export default "__VITE_ASSET__878114a7__"